<apex-page-info [title]="title"></apex-page-info>

<apex-cases #cases></apex-cases>
